// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3H1tX","left":"styles_left__yJNa5"};